{
  "name": "17-(11-Limit) Wilson",
  "description": "17-tone 11-Limit Rational Intonation scale by Erv Wilson, consisting of 17 notes per octave derived from harmonic partial row intervals up to a prime limit of 11. Wilson is one of the most important theorists of microtonal music research, inventing not only the hexagonal isomorphic keyboard layout featured in this web app, but also numerous key theoretical concepts relating to scale formation (moment of symmetry, combination product sets, etc.)",
  "scale": [
    "22/21",
    "11/10",
    "9/8",
    "7/6",
    "11/9",
    "5/4",
    "4/3",
    "11/8",
    "22/15",
    "3/2",
    "11/7",
    "44/27",
    "5/3",
    "7/4",
    "11/6",
    "15/8",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "17-JI-11L_Wilson",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "D",
    "D",
    "E",
    "E",
    "E",
    "F",
    "F",
    "G",
    "G",
    "G",
    "A",
    "A",
    "B",
    "B",
    "B"
  ],
  "note_colors": [
    "#ffb8b8",
    "#e0eccb",
    "#e3f5d0",
    "#ffffff",
    "#ffe5e5",
    "#dfffd6",
    "#fffae5",
    "#ffffff",
    "#dfffd6",
    "#e3f5d0",
    "#ffffff",
    "#e0eccb",
    "#dfffd6",
    "#fffae5",
    "#ffe5e5",
    "#dfffd6",
    "#fffae5"
  ],
  "equivSteps": 17,
  "fundamental": 260.740741,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 3,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
